// Vue
import { Vue, Component, Prop, Inject } from "vue-property-decorator";

// Template
import template from "./template.vue";

// Base Module
import ModuleBase from "#/common/ModuleBase";

// Components
import { Observer } from "mobx-vue";
import { reaction } from "mobx";
import { BodyBuilder } from "../../../common/interfaces/conversionworld/BodyBuilder";

@Observer
@Component({
  mixins: [template],
  components: {},
})
export class SeoPortraitModule extends ModuleBase {
  get bodyBuilder() {
    return this.$store.conversionWorld.bodyBuilder;
  }

  public getBackgroundColorFromInstance(instance: object) {
    return "black";
  }

  get url() {
    if (this.bodyBuilder) {
      return (
        "https://conversion-world.mercedes-benz.com/de/GLOBAL/partner-aufbauhersteller/" +
        this.bodyBuilder.id +
        "/" +
        this.bodyBuilder.slug
      );
    } else {
      return "";
    }
  }

  get name() {
    if (this.bodyBuilder) {
      return this.instance["name"] || this.bodyBuilder.name;
    } else {
      return "";
    }
  }

  get description() {
    return JSON.stringify(this.htmlDescription);
  }

  get htmlDescription() {
    if (this.bodyBuilder) {
      return this.instance["beschreibung"] || this.bodyBuilder.philosophy;
    } else {
      return "";
    }
  }

  get city() {
    if (this.bodyBuilder) {
      return this.instance["stadt"] || this.bodyBuilder.address.city;
    } else {
      return "";
    }
  }

  get postcode() {
    if (this.bodyBuilder) {
      return this.instance["plz"] || this.bodyBuilder.address.post_code;
    } else {
      return "";
    }
  }

  get address() {
    if (this.bodyBuilder) {
      return (
        this.instance["adresse"] ||
        (this.bodyBuilder.address.street || "") +
          (this.bodyBuilder.address.number || "")
      );
    } else {
      return "";
    }
  }

  get abhCountry() {
    if (this.bodyBuilder) {
      return this.instance["land"] || this.bodyBuilder.address.country.name;
    } else {
      return "";
    }
  }
}
